export class LocationUtils {
	static GetQueryParam(paramName) {
		const queryParams = new URLSearchParams(window.location.search);
		const paramValue =
			Array.from(queryParams.entries()).find((entry) => entry[0]?.toLowerCase() === paramName?.toLowerCase())?.[1] ?? null;

		return paramValue;
	}
}
